/**
 * Medidas da torre de treliça. A torre é larga o bastante para se trabalhar
 * dentro dela: patamares de grade a cada `espacoPatamarM` (com o alçapão da
 * escada de marinheiro num canto) e a plataforma do topo.
 */

/** Lado do alçapão da escada de marinheiro, num canto de cada patamar. */
export const ALCAPAO_TORRE_M = 0.8
/**
 * Altura dos pontos de ancoragem de cada patamar acima do piso, nos montantes:
 * 2 m, acima do engate de quem está de pé ali (a ancoragem acima do engate
 * deixa o fator de queda abaixo de 1).
 */
export const ANCORAGEM_ACIMA_DO_PATAMAR_M = 2
/** Um patamar não fica colado no topo: abaixo disto do topo, só a plataforma de cima. */
const FOLGA_TOPO_M = 0.6

/** As alturas dos patamares intermediários, de baixo para cima (sem o topo). */
export function alturasDosPatamares(alturaM: number, espacoPatamarM: number): readonly number[] {
  if (!(espacoPatamarM > 0)) return []
  const alturas: number[] = []
  for (let k = 1; k * espacoPatamarM <= alturaM - FOLGA_TOPO_M + 1e-9; k += 1) alturas.push(Math.round(k * espacoPatamarM * 1000) / 1000)
  return alturas
}

/**
 * O canto do alçapão de cada piso, alternando para o piso de cima não ficar
 * sobre o de baixo (quem cai por um alçapão para no piso de baixo, e a escada
 * de marinheiro sobe em lances): pisos de índice par no canto (-X, -Z), ímpar
 * no canto (+X, -Z). O índice conta os patamares de baixo para cima e, por
 * último, o topo.
 */
export function cantoDoAlcapao(indicePiso: number): readonly [number, number] {
  return indicePiso % 2 === 0 ? [-1, -1] : [1, -1]
}

/** Os pisos da torre, de baixo para cima: os patamares e, por último, o topo (com alçapão só acima de 2 m). */
export function pisosDaTorre(alturaM: number, espacoPatamarM: number): ReadonlyArray<{ readonly altura: number; readonly alcapao: readonly [number, number] | null }> {
  const patamares = alturasDosPatamares(alturaM, espacoPatamarM)
  return [...patamares, alturaM].map((altura, i) => ({
    altura,
    alcapao: i === patamares.length && alturaM <= 2 ? null : cantoDoAlcapao(i),
  }))
}
